"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.state = exports.api = exports.reducers = void 0;
// tslint:disable:max-file-line-count
const redux_1 = require("redux");
const api_1 = require("./api");
const actions_1 = require("./propertyAccounts/actions");
const reducer_1 = require("./propertyAccounts/reducer");
const actions_2 = require("./amenities/actions");
const reducer_2 = require("./amenities/reducer");
const actions_3 = require("./bathrooms/actions");
const reducer_3 = require("./bathrooms/reducer");
const actions_4 = require("./beds/actions");
const reducer_4 = require("./beds/reducer");
const actions_5 = require("./booking-summaries/actions");
const reducer_5 = require("./booking-summaries/reducer");
const actions_6 = require("./cancellation-preferences/actions");
const reducer_6 = require("./cancellation-preferences/reducer");
const actions_7 = require("./customers/actions");
const reducer_7 = require("./customers/reducer");
const actions_8 = require("./local_licence/actions");
const reducer_8 = require("./local_licence/reducer");
const actions_9 = require("./notifications/actions");
const reducer_9 = require("./notifications/reducer");
const actions_10 = require("./restrictions/actions");
const reducer_10 = require("./restrictions/reducer");
const actions_11 = require("./pricing/actions");
const reducer_11 = require("./pricing/reducer");
const actions_12 = require("./pricing-type/actions");
const reducer_12 = require("./pricing-type/reducer");
const actions_13 = require("./pricing-automatic-prices/actions");
const reducer_13 = require("./pricing-automatic-prices/reducer");
const actions_14 = require("./pricing-overrides/actions");
const reducer_14 = require("./pricing-overrides/reducer");
const actions_15 = require("./pricing-ui/actions");
const reducer_15 = require("./pricing-ui/reducer");
const actions_16 = require("./pricing-validation/actions");
const reducer_16 = require("./pricing-validation/reducer");
const actions_17 = require("./properties/actions");
const reducer_17 = require("./properties/reducer");
const actions_18 = require("./property-shell/actions");
const reducer_18 = require("./property-shell/reducer");
const actions_19 = require("./property-summaries/actions");
const reducer_19 = require("./property-summaries/reducer");
const actions_20 = require("./item-types/actions");
const reducer_20 = require("./item-types/reducer");
const actions_21 = require("./financial/actions");
const reducer_21 = require("./financial/reducer");
const actions_22 = require("./facts/actions");
const reducer_22 = require("./facts/reducer");
const actions_23 = require("./listing-contracts/actions");
const reducer_23 = require("./listing-contracts/reducer");
const actions_24 = require("./terms-contracts/actions");
const reducer_24 = require("./terms-contracts/reducer");
const actions_25 = require("./customerAccounts/actions");
const actions_26 = require("./availability/actions");
const reducer_25 = require("./availability/reducer");
const actions_27 = require("./booking-state/actions");
const reducer_26 = require("./booking-state/reducer");
const actions_28 = require("./availabilityV3/actions");
const actions_29 = require("./calendar-source/actions");
const reducer_27 = require("./calendar-source/reducer");
const actions_30 = require("./pricing-defaults/actions");
const reducer_28 = require("./pricing-defaults/reducer");
const actions_31 = require("./commission-deals/actions");
const reducer_29 = require("./commission-deals/reducer");
const actions_32 = require("./commission-channels/actions");
const reducer_30 = require("./commission-channels/reducer");
const actions_33 = require("./commissions/actions");
const reducer_31 = require("./commissions/reducer");
const actions_34 = require("./property-scores/actions");
const reducer_32 = require("./property-scores/reducer");
const actions_35 = require("./promotions/actions");
const reducer_33 = require("./promotions/reducer");
const actions_36 = require("./promotion-opportunities/actions");
const reducer_34 = require("./promotion-opportunities/reducer");
const actions_37 = require("./experiments/actions");
const reducer_35 = require("./experiments/reducer");
const actions = () => ({
    amenity: actions_2.actions(),
    availability: actions_26.actions(),
    availabilityV3: actions_28.actions(),
    bathroom: actions_3.actions(),
    bed: actions_4.actions(),
    bookingState: actions_27.actions(),
    bookingSummaries: actions_5.actions(),
    calendarSource: actions_29.actions(),
    cancellationPreference: actions_6.actions(),
    customer: actions_7.actions(),
    facts: actions_22.actions(),
    financial: actions_21.actions(),
    itemTypes: actions_20.actions(),
    localLicence: actions_8.actions(),
    notifications: actions_9.actions(),
    pricing: actions_11.actions(),
    pricingType: actions_12.actions(),
    pricingDefaults: actions_30.actions(),
    pricingAutomaticPrices: actions_13.actions(),
    pricingOverrides: actions_14.actions(),
    pricingUi: actions_15.actions(),
    pricingValidation: actions_16.actions(),
    property: actions_17.actions(),
    propertyAccount: actions_1.actions(),
    propertyShell: actions_18.actions(),
    propertySummary: actions_19.actions(),
    restrictions: actions_10.actions(),
    customerAccount: actions_25.actions(),
    listingContracts: actions_23.actions(),
    termsContracts: actions_24.actions(),
    commission: actions_33.actions(),
    commissionDeals: actions_31.actions(),
    commissionChannels: actions_32.actions(),
    propertyScores: actions_34.actions(),
    promotions: actions_35.actions(),
    promotionOpportunities: actions_36.actions(),
    experiments: actions_37.actions(),
});
exports.reducers = () => redux_1.combineReducers({
    accounts: reducer_1.reducer(),
    amenities: reducer_2.reducer(),
    availability: reducer_25.reducer(),
    bathrooms: reducer_3.reducer(),
    beds: reducer_4.reducer(),
    bookingState: reducer_26.reducer(),
    bookingSummaries: reducer_5.reducer(),
    calendarSource: reducer_27.reducer(),
    cancellationPreference: reducer_6.reducer(),
    customers: reducer_7.reducer(),
    facts: reducer_22.reducer(),
    financial: reducer_21.reducer(),
    itemTypes: reducer_20.propertyItemTypes,
    listingContracts: reducer_23.reducer(),
    localLicence: reducer_8.reducer(),
    notifications: reducer_9.reducer(),
    pricing: reducer_11.reducer(),
    pricingType: reducer_12.reducer(),
    pricingDefaults: reducer_28.reducer(),
    pricingAutomaticPrices: reducer_13.reducer(),
    pricingOverrides: reducer_14.reducer(),
    pricingUi: reducer_15.reducer(),
    pricingValidation: reducer_16.reducer(),
    properties: reducer_17.reducer(),
    propertyShell: reducer_18.reducer(),
    propertySummaries: reducer_19.reducer(),
    restrictions: reducer_10.reducer(),
    termsContracts: reducer_24.reducer(),
    commissionDeals: reducer_29.reducer(),
    commission: reducer_31.reducer(),
    commissionChannels: reducer_30.reducer(),
    propertyScores: reducer_32.reducer(),
    promotions: reducer_33.reducer(),
    promotionOpportunities: reducer_34.reducer(),
    experiments: reducer_35.reducer(),
});
exports.api = (config) => api_1.apiFactory(config);
exports.state = () => {
    return {
        reducer: exports.reducers(),
        actions: actions(),
    };
};
var selector_1 = require("./helpers/selector");
Object.defineProperty(exports, "memoizedGroupBySelector", { enumerable: true, get: function () { return selector_1.memoizedGroupBySelector; } });
var key_by_1 = require("./helpers/key-by");
Object.defineProperty(exports, "keyEntitiesBy", { enumerable: true, get: function () { return key_by_1.keyEntitiesBy; } });
//# sourceMappingURL=index.js.map